export default "__VITE_ASSET__DitRCRrE__"